module.exports = __webpack_public_path__ + "assets/img/help_image03-1@2x.038529b6.png";